import React, {useRef, useState} from 'react';
import {inputContainerProps} from '../../types';
import './InputContainer.css';

const InputContainer: React.FC<inputContainerProps> = ({updateInputValue}) => {
  const [inputText, setInputText] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);
  const isBtnDisable = inputText.length === 0;

  return (
    <div className="web-story-input-container">
      <div className="web-story-input-row">
        <input
          ref={inputRef}
          className="web-story-input"
          placeholder="type here..."
          value={inputText}
          maxLength={20}
          onChange={e => setInputText(e.target.value)}
          onKeyDown={e => {
            if (e.key === 'Enter' && !isBtnDisable) {
              updateInputValue(inputText);
            }
          }}
        />
        <button
          type="button"
          className="web-story-mic-btn"
          onClick={() => inputRef.current?.focus()}
          aria-label="Focus input">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="9" y="2" width="6" height="11" rx="3" fill="white"/>
            <path d="M5 11a7 7 0 0 0 14 0" stroke="white" strokeWidth="2" strokeLinecap="round"/>
            <line x1="12" y1="18" x2="12" y2="22" stroke="white" strokeWidth="2" strokeLinecap="round"/>
            <line x1="9" y1="22" x2="15" y2="22" stroke="white" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </button>
      </div>
      <button
        type="button"
        className="web-story-continue-btn"
        disabled={isBtnDisable}
        onClick={() => updateInputValue(inputText)}>
        Continue
      </button>
    </div>
  );
};

export default InputContainer;
